import React from "react";
import cx from "classnames";
import { IKImage } from "imagekitio-react";

import TruncateWithTooltip from "src/components/truncateWithTooltip";
import styles from "./browserTabBar.module.scss";

export interface BrowserTabBarClassNames {
  container?: string;
  tabBar?: string;
  tabs?: string;
  tab?: string;
  favIcon?: string;
  urlWrapper?: string;
  urlBar?: string;
  emptyArea?: string;
}

interface BrowserTabBarProps {
  icon?: string;
  tabName: string;
  tabURL: string;
  /** Convenience override for the root container class. */
  className?: string;
  /** Per-slot class overrides; each is merged onto the default style. */
  classNames?: BrowserTabBarClassNames;
}

const isRenderableUrl = (icon: string) =>
  icon.startsWith("data:") ||
  icon.startsWith("http://") ||
  icon.startsWith("https://");

const BrowserTabBar: React.FC<BrowserTabBarProps> = ({
  icon,
  tabName,
  tabURL,
  className,
  classNames = {},
}) => {
  return (
    <div className={cx(styles.tabBarContainer, className, classNames.container)}>
      <div className={cx(styles.tabBar, classNames.tabBar)}>
        <div className={cx(styles.tabs, classNames.tabs)}>
          <div className={styles.circleIcons}>
            <span className={styles.circle}></span>
            <span className={styles.circle}></span>
            <span className={styles.circle}></span>
          </div>
          <div className={cx(styles.tab, classNames.tab)}>
            <div>
              {icon && icon.length > 0 && (
                <div className={cx(styles.favIconContainer, classNames.favIcon)}>
                  {isRenderableUrl(icon) ? (
                    <img src={icon} alt="favicon" />
                  ) : (
                    <IKImage path={icon} alt="favicon" />
                  )}
                </div>
              )}
              <TruncateWithTooltip
                className={styles.tabName}
                placement="top"
                text={tabName}
              />
            </div>
            <i className="fa-solid fa-xmark"></i>
          </div>
          <i className={cx(styles.closeTabIcon, "paperflite-plus")}></i>
        </div>
        <div className={cx(styles.urlWrapper, classNames.urlWrapper)}>
          <div className={styles.iconsWrapper}>
            <i className={cx("paperflite-left-arrow")}></i>
            <i className={cx("paperflite-right-arrow", styles.iconDisable)}></i>
            <i className={cx("paperflite-reload", styles.reload)}></i>
            <i className={cx("paperflite-dashboard")}></i>
          </div>
          <div className={cx(styles.urlBar, classNames.urlBar)}>
            <i className={cx("paperflite-lock")}></i>
            <TruncateWithTooltip
              className={styles.urlText}
              placement="top"
              text={tabURL}
            />
            <i className={cx("fa-regular fa-star")}></i>
          </div>
          <i className="fa-solid fa-ellipsis-vertical"></i>
        </div>
        <div className={cx(styles.emptyArea, classNames.emptyArea)}></div>
      </div>
    </div>
  );
};

export default BrowserTabBar;
